<template>
  <v-row>
    <v-col cols="12" sm="12">
      <h2 class="text--primary text-xl font-weight-medium">
        {{ $t("Piiri-artikkelit") }}
      </h2>
      <br />
      <v-row>
        <template v-for="article in articles">
          <v-col lg="4" md="6" sm="12" :key="article.id">
            <v-card
              class="mx-auto"
              :to="{ name: 'piiri-article', params: { id: article.id } }"
            >
              <v-img class="white--text align-end" :src="article.image.full_hd">
              </v-img>
              <br />
              <v-card-text>
                <v-row align="center" class="mx-0">
                  <v-avatar size="48">
                    <v-img
                      v-if="Object.keys(article.author_image).length"
                      :src="article.author_image.thumbnail"
                    ></v-img>
                    <v-icon v-else color="primary">
                      {{ icons.mdiAccountCircle }}
                    </v-icon>
                  </v-avatar>

                  <div class="grey--text ml-4">
                    {{ article.author }} <br />{{
                      getDate(article.release_date)
                    }}
                  </div>
                </v-row>
              </v-card-text>
              <v-card-title>{{ article.title }}</v-card-title>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import api from "@/api";
import useAuth from "@/useAuth";
import { getDate } from "@/@core/utils/datetime_helpers";
import useMarkdown from "@/@core/utils/useMarkdown";
import { mdiAccountCircle } from "@mdi/js";

export default {
  setup() {
    const articles = ref([]);
    const { t } = useTranslations();
    const { markdownToHtml } = useMarkdown();

    // fetch data
    const fetchArticles = async () => {
      const response = await api.getPiiriArticles();

      articles.value = response.data.results;
    };

    onMounted(() => {
      fetchArticles();
    });

    return {
      articles,
      markdownToHtml,
      t,
      getDate,
      icons: {
        mdiAccountCircle,
      },
    };
  },
};
</script>

<style>
</style>